module.exports = __webpack_public_path__ + "static/media/adobe-xd.25990200.svg";